exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-e0921fbe] {\n  cursor: pointer;\n}", ""]);

// exports
